import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import moment from "moment/moment";
import { AuthenticationService } from "../services/authentication.service";
import { LogtoService } from "../services/logto.service";
import { NavigationService } from "../services/navigation.service";

@Component({
  selector: "app-admin-login",
  templateUrl: "./admin-login.component.html",
  styleUrls: ["./admin-login.component.css"],
})
export class AdminLoginComponent implements OnInit {
  loading = false;
  error: string | null = null;

  constructor(
    private logtoService: LogtoService,
    private authService: AuthenticationService,
    private router: Router,
  ) {}

  async ngOnInit() {
    // Shared invite link `/admin-login?screen=signup` → start registration directly
    // in the recipient's browser (generates their own PKCE for the callback).
    if (
      !this.logtoService.isCallbackUrl() &&
      new URLSearchParams(window.location.search).get("screen") === "signup"
    ) {
      try {
        await this.logtoService.signIn("register");
      } catch (e) {
        console.error("Logto signup redirect error:", e);
        this.error = "Could not start registration. Please try again.";
      }
      return;
    }

    if (this.logtoService.isCallbackUrl()) {
      this.loading = true;
      try {
        await this.logtoService.handleSignInCallback();
        const token = await this.logtoService.getAccessToken();
        if (token) {
          this.authService.setToken(token);
          localStorage.setItem("access_token", token);

          let expiresIn = 3600;
          try {
            const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
            const payload = JSON.parse(atob(base64));
            expiresIn = payload.exp - Math.floor(Date.now() / 1000);
          } catch {
            // opaque token — no JWT expiry, use 1h fallback
          }
          localStorage.setItem("expires_in", JSON.stringify(expiresIn));
          localStorage.setItem(
            "expires_at",
            moment().add(expiresIn, "seconds").toLocaleString(),
          );

          localStorage.setItem("login_provider", "logto");
          this.authService.isAdmin.next(true);
          this.authService.refreshCurrentRoles();
          this.router.navigate([NavigationService.ADMINPAGE]);
        } else {
          this.error = "Could not retrieve access token.";
          this.loading = false;
        }
      } catch (e) {
        console.error("Logto callback error:", e);
        this.error = "Login failed. Please try again.";
        this.loading = false;
      }
    }
  }

  async onLogin() {
    try {
      await this.logtoService.signIn();
    } catch (e) {
      console.error("Logto sign in error:", e);
      this.error = "Could not initiate login. Please try again.";
    }
  }
}
